import React from 'react';
import { connect } from 'react-redux';

import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { Thumbnail } from '~src/spacesPlatform/components/card/Thumbnail';
import { Hover } from '~src/spacesPlatform/components/Explorer/widgets/Hover';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { TooltipAnchor } from '~src/spacesPlatform/components/tooltip/TooltipAnchor';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { isFavoritesSpace } from '~src/spacesPlatform/state/SpaceInfo';
import { isViewTooltipContentUnfocusable, ViewTooltip } from '~src/views/components/ViewTooltip';
import { Views } from '~src/views/resources/Views';

export interface ConnectedViewThumbnailOwnProps {
    connectedViewId: string;
    connectedViewThumbnailUrl: string;
    connectedViewUrl: string;
    connectedViewName: string;
}

export interface ConnectedViewThumbnailStateProps {
    urls: SpacesSiteUrls;
    allowDragAndDrop: boolean;
}

export interface ConnectedViewThumbnailStates {
    isHovered: boolean;
    connectedViewContentInfo: IContentInfo;
}

export type ConnectedViewThumbnailProps = ConnectedViewThumbnailOwnProps & ConnectedViewThumbnailStateProps;

export const THUMBNAIL_WIDTH = 177;
export const THUMBNAIL_HEIGHT = 108;

export class ConnectedViewThumbnailPresentation extends React.PureComponent<ConnectedViewThumbnailProps, ConnectedViewThumbnailStates> {
    constructor(props: ConnectedViewThumbnailProps) {
        super(props);

        this.state = {
            isHovered: false,
            connectedViewContentInfo: null
        };

        this.getViewContentDetail();
    }

    public componentDidUpdate(prevProps: ConnectedViewThumbnailProps) {
        if (prevProps.connectedViewId !== this.props.connectedViewId) {
            this.getViewContentDetail();
        }
    }

    public render() {
        const disableAutoFocus = isViewTooltipContentUnfocusable(this.state.connectedViewContentInfo);

        return <div style={{ width: THUMBNAIL_WIDTH + 'px' }}>
            <Hover groupName="metric-detail-connected-view" onEnter={this.activateHover} onLeave={this.deactivateHover}>
                {this.state.connectedViewContentInfo ?
                    <TooltipAnchor tooltipContent={this.renderTooltipContent}
                        width={DetailsTooltipStyles.Width}
                        title={Messages.viewTooltipTitle()} disableAutoFocus={disableAutoFocus}>
                        {this.renderThumbnail()}
                    </TooltipAnchor>
                    : this.renderThumbnail()
                }
            </Hover>
        </div>;
    }

    private renderThumbnail = () => {
        return <Thumbnail navigateUrl={this.props.connectedViewUrl}
            openLinkInNewTab
            defaultImageUrl={imgPath('spaces_card_view.svg')}
            thumbnailImageUrl={this.props.connectedViewThumbnailUrl}
            hoveredOrSelected={this.state.isHovered}
            customHeight={THUMBNAIL_HEIGHT}
            allowDragAndDrop={this.props.allowDragAndDrop}
            allowFocusIndicator
            aria-label={Messages.metricConnectedViewWithName({
                CONNECTED_VIEW_NAME: this.props.connectedViewName
            })
        }
        />;
    };

    private activateHover = () => {
        this.setState({ isHovered: true });
    };

    private deactivateHover = () => {
        this.setState({ isHovered: false });
    };

    private getViewContentDetail = async () => {
        try {
            const result = await Views.getById(this.props.connectedViewId);
            this.setState({ connectedViewContentInfo: { ...result } });
        } catch (e) {
            this.setState({ connectedViewContentInfo: null });
        }
    };

    private renderTooltipContent = () => {
        return this.state.connectedViewContentInfo ? <ViewTooltip content={this.state.connectedViewContentInfo}
            urls={this.props.urls}
            inProjectSpace={false} /> : null;
    };
}

const mapStateToProps: MapStateToProps<ConnectedViewThumbnailStateProps> = (state: AppState) => {
    return {
        urls: siteUrlsSelector(state),
        allowDragAndDrop: isFavoritesSpace(state.spaceInfo), // soon collections too!
    };
};

export const ConnectedViewThumbnail = connect(mapStateToProps)(ConnectedViewThumbnailPresentation);
